import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
  faPhone,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MODEL } from "../../../model";

export default function SignupForm() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });
  const [message, setMessage] = useState({
    error: false,
    text: "",
  });
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    api: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: sanitizeInput(e.target.value),
    });
  };

  // Regex patterns for validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email validation
  const phoneRegex = /^[0-9]{10,14}$/; // Accepts 10-14 digit phone numbers
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/; // Min 8 chars, 1 letter, 1 number, 1 special char

  // Sanitize input (Basic)
  const sanitizeInput = (input) => {
    return input.replace(/['";`\\]+/g, ""); // Removes special characters that may cause SQL injection
  };
  const validateForm = () => {
    let valid = true;
    const newErrors = {
      name: "",
      email: "",
      phone: "",
      password: "",
    };

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
      valid = false;
    }

    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
      valid = false;
    }

    if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Phone number must be between 10 and 14 digits.";
      valid = false;
    }

    if (!passwordRegex.test(formData.password)) {
      newErrors.password =
        "Password must be at least 8 characters long and include a number, a letter, and a special character.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true); // Start loading
      signupReq(formData);
      setIsLoading(false); // Start loading
      setMessage({ error: false, text: "Form submitted successfully!" });
      navigate("/signin");
    } else {
      setMessage({ error: false, text: "" });
    }
  };

  const signupReq = async (data) => {
    try {
      const signup_api_url = `${MODEL.api.base_url}/api/auth/signup`;
      const response = await fetch(signup_api_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setMessage({
          error: false,
          text: "Signup successful! Please check your email.",
        });
        setFormData({ name: "", phone: "", email: "", password: "" });
      } else {
        const data = await response.json();

        setMessage({
          error: true,
          text: data.message || "An error occurred during signup.",
        });
      }
    } catch {
      setMessage({
        error: true,
        text: "Network error. Please try again later.",
      });
    }
  };
  return (
    <div className="container">
      <div className="background"></div>
      <div className="gradient"></div>

      <div className="content-wrapper">
        <div className="taglines">
          <h2>Start Your Journey today</h2>
          <p className="quote">"SEED TO TREE"</p>
          <p className="quote delay">"ACADEMY"</p>
        </div>

        <div className="form-wrapper">
          <div className="form-container">
            <h2>Create Account</h2>
            <form onSubmit={handleSubmit}>
              {message.text !== "" && (
                <p
                  className={
                    message.error ? "error-message" : `success-message`
                  }
                >
                  {message.text}
                </p>
              )}

              <div className="input-group">
                <label for="name">Name</label>
                <div className="input-wrapper">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    onChange={handleChange}
                  />

                  <FontAwesomeIcon icon={faUser} className="icon" />
                </div>
                {errors.name && <p className="error-message">{errors.name}</p>}
              </div>

              <div className="input-group">
                <label for="phone">Mobile</label>
                <div className="input-wrapper">
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder="Enter your phone number"
                    onChange={handleChange}
                  />

                  <FontAwesomeIcon icon={faPhone} className="icon" />
                </div>
                {errors.phone && (
                  <p className="error-message">{errors.phone}</p>
                )}
              </div>

              <div className="input-group">
                <label for="email">Email</label>
                <div className="input-wrapper">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    onChange={handleChange}
                  />
                  <FontAwesomeIcon icon={faEnvelope} className="icon" />
                </div>
                {errors.email && (
                  <p className="error-message">{errors.email}</p>
                )}
              </div>

              <div className="input-group">
                <label htmlFor="password">Password</label>
                <div className="input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    onChange={handleChange}
                    value={formData.password}
                  />
                  <FontAwesomeIcon icon={faLock} className="icon" />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="toggle-password"
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                {errors.password && (
                  <p className="error-message">{errors.password}</p>
                )}
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isLoading}
              >
                {isLoading ? "Signing Up..." : "Sign Up"}
              </button>

              <div className="signin-link">
                <span>Already have an account?</span>
                <Link to="/signin">Sign In</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
